//assumes knockout is loaded

/**
 * AccountUser model
 * @name AccountUser
 * @class
 */
class AccountUser
{
	constructor(options)
	{
		this.user_id = ko.observable(options.user_id);
		this.username = ko.observable(options.username);
		this.email = ko.observable(options.email);
		this.user_active = ko.observable(options.active || options.user_active);
	}

	/**
	 * Function to load an AccountUser
	 * @memberof AccountUser
	 * @instance
	 */
	async load(account_user_id){

	}

	/**
	 * Function to delete an AccountUser
	 * @memberof AccountUser
	 * @instance
	 */
	async delete(options){
	}
}

 export default AccountUser;
